import React, {Component} from "react";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

class SimpleTextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: props.value ? props.value : '',
            defaultText: props.value ? props.value : ''
        }
        this.handleChange = this.handleChange.bind(this)
    }
    handleChange = (text) => {
        this.props.onChange(text)
    }
    render() {
        const {label, mandatory, height, value, placeholder, readOnly} = this.props
        return (
            <div className="margin-bottom-20px">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{color: 'red'}}>*</span>}</h4>
                    </div>
                </div>
                <div>
                    <SunEditor 
                        placeholder={placeholder}
                        height={height ? height : '250px'} 
                        hideToolbar={readOnly} 
                        disable={readOnly} 
                        setContents={value}
                        autoFocus={false}
                        onChange={this.handleChange} 
                        setDefaultStyle="font-family: sans-serif; font-face: sans-serif;"
                        setOptions={{
                            buttonList : [
                                ['undo', 'redo', 'fontSize', 'formatBlock'],
                                ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
                                [
                                    '-right', ':i-More Misc-default.more_vertical',
                                    'fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table',
                                    'link', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print'
                                ]
                            ]
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default SimpleTextEditor